import axios, {AxiosError, AxiosResponse} from "axios";
import { IApiResponseDto } from '../dto/common/ApiResponseDto';
import { CookieManager } from '../utility/CookieManager';

export class BaseApiService<TDto> {

    protected static errorApiHandle(error: any) {
        console.log(error);
        if (error.response.status === 401) {
            window.location.href = "/login";
        }

    }

    protected prefixUrl: string = "";
    protected httpHeader = {};

    constructor(controller: string) {
        this.prefixUrl = `https://api.sisaka.sanurkauh.desa.id/api/${controller}`;
    }

    public getAll() {

        const url = this.prefixUrl + "/GetAll";

        return axios.get(url, { headers: this.getHttpHeader() })
            .then(res => {
                return res.data;

            }).catch(error => {
                BaseApiService.errorApiHandle(error);
                return error.data;

            });

    }

    public create(data: TDto) {

        const url = this.prefixUrl + "/Create";
        const dto = JSON.stringify(data);

        return this.postRequest(url, dto);

    }

    public createWithUploadFile(data: any) {

        const url = this.prefixUrl + "/CreateWithFile";

        return new Promise((resolve, reject) => {
            axios.post(url, data, {
                headers: {
                    'Content-Type': "multipart/form-data",
                    'Authorization': "Bearer " + CookieManager.getSession()
                }
            }).then(res => {
                resolve(res.data);

            }).catch(error => {
                BaseApiService.errorApiHandle(error);
                reject(error.response.data);

            });
        });

    }

    public read(id: string) {
        const url = this.prefixUrl + "/Read?id=" + id;

        return this.getRequest(url);

    }

    public update(id: string, data: any) {

        const url = this.prefixUrl + "/Update?id=" + id;
        const dto = JSON.stringify(data);

        return this.putRequest(url, dto);

    }

    public updateWithFile(accessToken: string, data: FormData) {

        const url = this.prefixUrl + "/UpdateWithFile?accessToken=" + accessToken;

        return new Promise((resolve, reject) => {

            axios.put(url, data, {
                headers: {
                    'Content-Type': "multipart/form-data",
                    'Authorization': localStorage.getItem("token")
                }
            }).then(res => {
                resolve(res.data);

            }).catch(error => {
                BaseApiService.errorApiHandle(error);
                reject(error.response.data);

            });
        });

    }

    public delete(id: string) {

        const url = this.prefixUrl + "/Delete?id=" + id;

        return this.deleteRequest(url);

    }

    public getDictionaryJson() {

        const url = this.prefixUrl + "/GetAllDictionary";

        return this.getRequest(url);

    }

    public count() {

        const url = this.prefixUrl + "/Count";

        return axios.get(url, {
            headers: {
                'Content-Type': "application/json",
                'Authorization': localStorage.getItem("token")
            }
        }).then(res => {
            return res.data;

        }).catch(error => {
            BaseApiService.errorApiHandle(error);
            return error.data;

        });

    }

    public getDtJsonUrl(): string {
        return this.prefixUrl + "/GetDtJson";
    }

    protected getHttpHeader() {

        const token = CookieManager.getSession();

        this.httpHeader = {
            'Content-Type': "application/json",
            'Authorization': "Bearer " + token
        };

        return this.httpHeader;
    }

    protected getFormDataHttpHeader() {

        const token = CookieManager.getSession();

        this.httpHeader = {
            'Content-Type': "multipart/form-data",
            'Authorization': "Bearer " + token
        };

        return this.httpHeader;
    }

    protected postRequest(
        url: string,
        jsonData: string,
        successCallback?: (response: IApiResponseDto) => void,
        failCallback?: (response: IApiResponseDto) => void){

        return new Promise((resolve, reject) => {
            axios.post(url, jsonData, {
                headers: this.getHttpHeader()

            }).then((response: AxiosResponse<IApiResponseDto>) => {

                if(response.data.isSuccess){

                    if(successCallback !== undefined){
                        successCallback(response.data);
                    }

                    resolve(response.data);

                }else{

                    if(failCallback !== undefined){
                        failCallback(response.data);
                    }

                    reject(response.data);

                }

            }).catch((error: AxiosError) => {

                BaseApiService.errorApiHandle(error);

                const errorResponse: IApiResponseDto = {
                    isSuccess: false,
                    result: null,
                    statusCode: '',
                    errorMessage: 'Application Error'
                };


                if(failCallback !== undefined){
                    failCallback(errorResponse);
                }

                reject(errorResponse);

            });
        });

    }

    protected getRequest(
        url: string,
        successCallback?: (response: IApiResponseDto) => void,
        failCallback?: (response: IApiResponseDto) => void){

        return new Promise((resolve, reject) => {
            axios.get(url, {
                headers: this.getHttpHeader()

            }).then((response: AxiosResponse<IApiResponseDto>) => {

                if(response.data.isSuccess){

                    if(successCallback !== undefined){
                        successCallback(response.data);
                    }

                    resolve(response.data);

                }else{

                    if(failCallback !== undefined){
                        failCallback(response.data);
                    }

                    reject(response.data);

                }

            }).catch((error: AxiosError) => {

                const errorResponse: IApiResponseDto = {
                    isSuccess: false,
                    result: null,
                    statusCode: '',
                    errorMessage: 'Application Error'
                };


                if(failCallback !== undefined){
                    failCallback(errorResponse);
                }

                reject(errorResponse);

            });
        });

    }

    protected putRequest(
        url: string,
        jsonData: string,
        successCallback?: (response: IApiResponseDto) => void,
        failCallback?: (response: IApiResponseDto) => void){

        return new Promise((resolve, reject) => {
            axios.put(url,  jsonData,{
                headers: this.getHttpHeader()

            }).then((response: AxiosResponse<IApiResponseDto>) => {

                if(response.data.isSuccess){

                    if(successCallback !== undefined){
                        successCallback(response.data);
                    }

                    resolve(response.data);

                }else{

                    if(failCallback !== undefined){
                        failCallback(response.data);
                    }

                    reject(response.data);

                }

            }).catch((error: AxiosError) => {

                const errorResponse: IApiResponseDto = {
                    isSuccess: false,
                    result: null,
                    statusCode: '',
                    errorMessage: 'Application Error'
                };


                if(failCallback !== undefined){
                    failCallback(errorResponse);
                }

                reject(errorResponse);

            });
        });

    }

    protected deleteRequest(
        url: string,
        successCallback?: (response: IApiResponseDto) => void,
        failCallback?: (response: IApiResponseDto) => void){

        return new Promise((resolve, reject) => {
            axios.delete(url,{
                headers: this.getHttpHeader()

            }).then((response: AxiosResponse<IApiResponseDto>) => {

                if(response.data.isSuccess){

                    if(successCallback !== undefined){
                        successCallback(response.data);
                    }

                    resolve(response.data);

                }else{

                    if(failCallback !== undefined){
                        failCallback(response.data);
                    }

                    reject(response.data);

                }

            }).catch((error: AxiosError) => {

                const errorResponse: IApiResponseDto = {
                    isSuccess: false,
                    result: null,
                    statusCode: '',
                    errorMessage: 'Application Error'
                };


                if(failCallback !== undefined){
                    failCallback(errorResponse);
                }

                reject(errorResponse);

            });
        });

    }

}


// WEBPACK FOOTER //
// ./src/core/api/BaseApiService.tsx